import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !original.url?.includes("/auth/")
    ) {
      original._retry = true;
      try {
        await client.post("/auth/refresh");
        return client(original);
      } catch (refreshErr) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

// ---------- Public content ----------
export const submitLead = (payload) => client.post("/contact", payload);
export const getPage = (slug) => client.get(`/content/pages/${slug}`).then((r) => r.data);
export const getServices = (category) =>
  client.get(`/content/services`, { params: category && category !== "all" ? { category } : {} }).then((r) => r.data);
export const getService = (slug) => client.get(`/content/services/${slug}`).then((r) => r.data);
export const getSettings = () => client.get(`/content/settings`).then((r) => r.data);
export const getPosts = () => client.get(`/content/posts`).then((r) => r.data);
export const getPost = (slug) => client.get(`/content/posts/${slug}`).then((r) => r.data);
export const getTracking = () => client.get(`/content/tracking`).then((r) => r.data);

// ---------- Auth ----------
export const login = (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data);
export const logout = () => client.post("/auth/logout");
export const getMe = () => client.get("/auth/me").then((r) => r.data);

// ---------- Admin: Pages ----------
export const adminListPages = () => client.get("/admin/pages").then((r) => r.data);
export const adminGetPage = (slug) => client.get(`/admin/pages/${slug}`).then((r) => r.data);
export const adminUpdatePage = (slug, payload) => client.put(`/admin/pages/${slug}`, payload).then((r) => r.data);

// ---------- Admin: Services ----------
export const adminListServices = () => client.get("/admin/services").then((r) => r.data);
export const adminGetService = (slug) => client.get(`/admin/services/${slug}`).then((r) => r.data);
export const adminCreateService = (payload) => client.post("/admin/services", payload).then((r) => r.data);
export const adminUpdateService = (slug, payload) => client.put(`/admin/services/${slug}`, payload).then((r) => r.data);
export const adminDeleteService = (slug) => client.delete(`/admin/services/${slug}`).then((r) => r.data);

// ---------- Admin: Posts ----------
export const adminListPosts = () => client.get("/admin/posts").then((r) => r.data);
export const adminGetPost = (slug) => client.get(`/admin/posts/${slug}`).then((r) => r.data);
export const adminCreatePost = (payload) => client.post("/admin/posts", payload).then((r) => r.data);
export const adminUpdatePost = (slug, payload) => client.put(`/admin/posts/${slug}`, payload).then((r) => r.data);
export const adminDeletePost = (slug) => client.delete(`/admin/posts/${slug}`).then((r) => r.data);

// ---------- Admin: Leads ----------
export const adminListLeads = () => client.get("/admin/leads").then((r) => r.data);
export const adminUpdateLeadStatus = (id, status) => client.patch(`/admin/leads/${id}/status`, { status }).then((r) => r.data);
export const adminDeleteLead = (id) => client.delete(`/admin/leads/${id}`).then((r) => r.data);

// ---------- Admin: Settings ----------
export const adminGetSettings = () => client.get("/admin/settings").then((r) => r.data);
export const adminUpdateSettings = (payload) => client.put("/admin/settings", payload).then((r) => r.data);

// ---------- Admin: Tracking Codes ----------
export const adminGetTracking = () => client.get("/admin/tracking").then((r) => r.data);
export const adminUpdateTracking = (payload) => client.put("/admin/tracking", payload).then((r) => r.data);

// ---------- Admin: Analytics Embeds ----------
export const adminGetAnalyticsEmbeds = () => client.get("/admin/analytics-embeds").then((r) => r.data);
export const adminUpdateAnalyticsEmbeds = (payload) => client.put("/admin/analytics-embeds", payload).then((r) => r.data);

// ---------- Admin: Upload ----------
export const adminUploadFile = (file) => {
  const form = new FormData();
  form.append("file", file);
  return client.post("/admin/upload", form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
